import React, { useState, useRef, useEffect } from 'react';
import { optimize } from './LazyImage';

const LazyBackgroundImage = ({
  src,
  className = '',
  isHero = false,
  optWidth = 1080,
  children,
  ...props
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [isInView, setIsInView] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Preload hero images immediately
    if (isHero) {
      setIsInView(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '50px',
        threshold: 0.1
      }
    );

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => observer.disconnect();
  }, [isHero]);

  const handleImageLoad = () => {
    setIsLoaded(true);
  };

  // Preload the image when it comes into view
  useEffect(() => {
    if (isInView && src) {
      const img = new Image();
      img.onload = handleImageLoad;
      img.src = optimize(src, optWidth);
    }
  }, [isInView, src, optWidth]);

  return (
    <div 
      ref={containerRef} 
      className={`lazy-background-container ${className} ${isLoaded ? 'loaded' : ''}`}
      style={{
        backgroundImage: isInView ? `url("${optimize(src, optWidth)}")` : 'none',
        filter: isLoaded ? 'blur(0)' : 'blur(5px)',
        opacity: isLoaded ? 1 : 0.7,
        transition: 'opacity 0.6s ease, filter 0.6s ease'
      }}
      {...props}
    >
      {children}
    </div>
  );
};

export default LazyBackgroundImage;
